import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import * as CategoriaCrud from 'services/categoria.service'

const CategoriaFormGroup = ({
  iError,
  iTouched,
  fIsSubmitting,
  values,
  setValues,
  handleChange
}) => {
  const [categorias, setCategorias] = React.useState([])

  React.useEffect(() => {
    CategoriaCrud.obtenerAsSelect().then(({ data }) => setCategorias(data))
  }, [])

  const categoriaChangeHandler = React.useCallback(
    e => {
      handleChange(e)
      values._idCategoria = e.target.value
      setValues(values)
    },
    [values, setValues, handleChange]
  )

  return (
    <>
      <Form.Group>
        <Form.Label text='CATEGORÍA' htmlFor='select-categoria' md={5} alignRightAt='md' />
        <Col md={7}>
          <Form.InputGroup>
            <Field name='_idCategoria'>
              {({ field }) => (
                <Form.Select
                  {...field}
                  disabled={fIsSubmitting}
                  isInvalid={iTouched && iError}
                  onChange={categoriaChangeHandler}
                  id='select-categoria'
                >
                  <option value=''>Seleccionar</option>
                  {categorias &&
                    categorias.map((val, key) => (
                      <option key={key} value={val._id}>
                        {val.nombre}
                      </option>
                    ))}
                </Form.Select>
              )}
            </Field>
          </Form.InputGroup>
          {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
        </Col>
      </Form.Group>
    </>
  )
}

export default React.memo(CategoriaFormGroup)
